import { Component, Input, ViewChild, HostListener, Output, EventEmitter } from '@angular/core';
import { Utils } from '../../../../utils';
import { AdsComponent } from '../../ads.component';
@Component({
    selector: 'ad-platform',
    templateUrl: 'ad-platform.component.html'
})
export class AdPlatformComponent {
    panelOpen = false;
    platformList = [];
    private _canEdit = false;
    private _listOnly = false;
    private _ad;
    @Input('canEdit') 
    set canEdit(canEdit) {
        this._canEdit = canEdit;
    }
    get canEdit() {
        return this._canEdit;
    }
    @Input('listOnly') 
    set listOnly(listOnly) {
        this._listOnly = listOnly;
    }
    get listOnly() {
        return this._listOnly;
    }
    @Input('ad') 
    set ad(ad) {
        this._ad = ad;
    }
    get ad() {
        return this._ad;
    }
    @Output() adPlatformChanged = new EventEmitter();
    @ViewChild('dropdown') dropdown;
    @HostListener('document:click', ['$event'])
    clickout(event) {
        if( this.dropdown && !this.dropdown.nativeElement.contains(event.target)) {
            this.panelOpen = false;
        }
    }
    constructor(public utils: Utils) {}
    ngAfterViewInit() {
        this.platformList = AdsComponent.platformList.map(platform => {
            return {
                name: platform.name,
                checked: this.ad.platforms.indexOf(platform.name) > -1
            }
        });
    }
    changePlatforms(platform) {
        const platforms = this.ad.platforms;
        if( platform.checked ) {
            if( platforms.indexOf(platform.name) === -1 ) {
                platforms.push(platform.name);
                this.adPlatformChanged.emit({
                    ad: this.ad,
                    added: true
                });
            }
        } else {
            let i = platforms.length;
            while(i--) {
                if( platforms[i] == platform.name ) {
                    platforms.splice(i, 1);
                    this.adPlatformChanged.emit({
                        ad: this.ad,
                        added: false
                    });
                    break;
                }
            }
        }
    }
    togglePanel() {
        this.panelOpen = !this.panelOpen;
    }
    getAdPlatformList() {
        return this.ad.platforms.join(', ');
    }
}